import { createLogger } from "logging";

const logger = createLogger("ChoiceModel");

export interface ChoiceModel<T = unknown> {
  name: string;
  text: string;
  value: T;
  tooltip?: string;
  disabled: boolean;
  isDefault?: boolean;
}

export type NumberChoiceModel = ChoiceModel;

export type StringChoiceModel = ChoiceModel<string>;

export function getChoice<T extends ChoiceModel, TValue>(name: string, choices: T[], value: TValue): T | undefined {
  let match = choices.find((f) => f.value === value);
  if (match != null) {
    logger.trace(`getChoice(${name}): found exact match:=`, match, `for value:`, value);
    return match;
  }

  match = choices.find((f) => `${f.value}` === `${value}`);
  if (match != null) {
    logger.trace(`getChoice(${name}): found string match:=`, match, `for value:`, value);
    return match;
  }

  match = choices.find((c) => c.isDefault === true);
  if (match != null) {
    logger.trace(`getChoice(${name}): did not found match, using default:=`, match, `for value:`, value);
    return match;
  }

  return undefined;
}
